import "../styles/chessboard-spinner.css";

// Create a DOM element for the loading spinner
const loading = document.createElement("span");
loading.classList.add("chessboard-spinner");
loading.innerHTML = "<span></span><span></span><span></span><span></span>";

export { loading }
